import { Component, Input } from '@angular/core'
import { Address } from 'modules/deals/configurator/ui/models/address'

@Component({
    selector: 'mg-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
})
export class AddressComponent {
    @Input() address: Address

    getAddressHTML(address: Address) {
        if (!address) {
            return '-'
        }

        const lineOne = address.street
            ? `${address.street} ${(address?.houseNumber || '') + (address.houseNumberSuffix || '')}<br>`
            : ''
        const lineTwo = [address?.zipcode, address?.city].map(v => v).join(' ')

        return lineOne.trim() || lineTwo.trim() ? `<address>${lineOne + lineTwo}</address>` : '-'
    }
}
